import _ from 'lodash';

const storageKey = 'BACK_URL';

export const setBackUrl = (backUrl) => {
  try {
    const str = JSON.stringify(_.pick(backUrl, ['hash', 'pathname', 'search']));
    localStorage.setItem(storageKey, str);
  } catch {}
};

export const getBackUrl = () => {
  try {
    const backUrl = JSON.parse(localStorage.getItem(storageKey));
    localStorage.removeItem(storageKey);

    return backUrl;
  } catch {
    return undefined;
  }
};
